// @flow
import React from 'react';
import type {Node} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {Api} from '@wellstone-solutions/common';
import {Routes} from 'components/Routes';
import {baseUrl} from 'api';
import {AppContainer, ErrorBoundary} from 'modules/app';
import {Providers} from './Providers';
import {routes} from './routes';
import {storage} from 'utils/storage';
import {AUTH_STORAGE_KEY} from 'modules/auth/store';

const apiVersions = [
  Api.API_VERSIONS.V1,
  Api.API_VERSIONS.REST,
  Api.API_VERSIONS.V2,
];
apiVersions.forEach((version) => {
  Api.configure({
    baseURL: baseUrl,
    version,
    headers: {
      common: {
        'x-client-version': `navigator,${String(
          process.env.REACT_APP_NAVIGATOR_VERSION,
        )}`,
        'x-user-time-zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    },
    onTokenRefresh: (v2Tokens: {access: string, refresh: string}) => {
      storage.setItem(AUTH_STORAGE_KEY, v2Tokens);
      return Promise.resolve();
    },
  });
});

const App = (): Node => {
  return (
    <ErrorBoundary>
      <Providers>
        <AppContainer>
          <Router basename={process.env.PUBLIC_URL}>
            <Routes routes={routes} />
          </Router>
        </AppContainer>
      </Providers>
    </ErrorBoundary>
  );
};

export default App;
